var _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSatelliteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38672 12.9373L9.41797 11.906",
    stroke: "#9D9D9D",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9658 9.35831L12.9971 8.32703",
    stroke: "#9D9D9D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82612 11.2234C5.11901 10.9306 5.59388 10.9306 5.88678 11.2234L9.77586 15.1125C10.0688 15.4054 10.0688 15.8803 9.77586 16.1732L8.18487 17.7642L3.23512 12.8144L4.82612 11.2234Z",
    stroke: "#9D9D9D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4052 1.64471C14.6981 1.35182 15.173 1.35182 15.4659 1.64471L19.355 5.5338C19.6479 5.82669 19.6479 6.30156 19.355 6.59446L17.764 8.18545L12.8142 3.2357L14.4052 1.64471Z",
    stroke: "#9D9D9D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.0361,
    y: 7.42822,
    width: 5.57645,
    height: 3.60324,
    rx: 0.75,
    transform: "rotate(45 10.0361 7.42822)",
    stroke: "#9D9D9D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.23535 12.8145L8.1851 17.7642L6.59411 19.3552C6.30122 19.6481 5.82634 19.6481 5.53345 19.3552L1.64436 15.4661C1.35147 15.1732 1.35147 14.6983 1.64436 14.4054L3.23535 12.8145Z",
    stroke: "#9D9D9D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8145 3.23572L17.7642 8.18547L16.1732 9.77646C15.8803 10.0693 15.4054 10.0693 15.1126 9.77646L11.2235 5.88737C10.9306 5.59448 10.9306 5.1196 11.2235 4.82671L12.8145 3.23572Z",
    stroke: "#9D9D9D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4096 18.5563C16.3124 18.6171 18.6165 16.313 18.5557 13.4103",
    stroke: "#9D9D9D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6341 15.9908C14.5275 16.0304 16.0299 14.5277 15.9902 12.6346",
    stroke: "#9D9D9D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatelliteIcon);
export default __webpack_public_path__ + "static/media/satelliteIcon.7d2d518598d5d7337a797628ca7f4d1b.svg";
export { ForwardRef as ReactComponent };